import AcEnrollAudit from './src/main';

/* istanbul ignore next */
AcEnrollAudit.install = function(Vue) {
  Vue.component(AcEnrollAudit.name, AcEnrollAudit);
};

export default AcEnrollAudit;
